import { render } from "./TrainingPagination.vue?vue&type=template&id=16592e06&scoped=true"
import script from "./TrainingPagination.vue?vue&type=script&lang=js"
export * from "./TrainingPagination.vue?vue&type=script&lang=js"

import "./TrainingPagination.vue?vue&type=style&index=0&id=16592e06&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16592e06"]])

export default __exports__